import { create } from 'zustand';
import { authApi } from '../services/api';

const useStore = create((set, get) => ({
  user:        null,
  token:       localStorage.getItem('aays_token') || null,
  authLoading: true,    // ← starts as true

  setToken: (token) => {
    localStorage.setItem('aays_token', token);
    set({ token });
  },

  fetchMe: async () => {
    set({ authLoading: true });
    try {
      const { data } = await authApi.me();
      set({ user: data.data, authLoading: false });
    } catch {
      set({ user: null, token: null, authLoading: false });
      localStorage.removeItem('aays_token');
    }
  },

  logout: async () => {
    try { await authApi.logout(); } catch {}
    localStorage.removeItem('aays_token');
    set({ user: null, token: null, authLoading: false });
  },

  // ── Sidebar ────────────────────────────────────────────────────────────────
  sidebarCollapsed: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

  // ── Leave balance cache ───────────────────────────────────────────────────
  leaveBalances: [],
  takenSickLeave: 0,
  takenSpecialLeave: 0,
  setLeaveBalances: (balances) => set({ leaveBalances: balances }),
  setTakenSickLeave: (takenSickLeave) => set({ takenSickLeave }),
  setTakenSpecialLeave: (takenSpecialLeave) => set({ takenSpecialLeave }),
}));

export default useStore;